import React from "react";
import TooltipOffers from "../../../../shared/create-offer/TooltipOffers/TooltipOffers";
import { intFormat } from "../../../../shared/create-offer/utils/formats";

export const AverageMessage = ({
	averageMiles,
	averageMilesSuggestion,
	data,
	minMiles,
	maxAverage
}) => {
	let percentage = "0.00";

	if (data.length && averageMiles > 25000) {
		const [statisticSales] = data.filter(
			item => averageMiles >= item.initialMiles && averageMiles <= item.finalMiles
		);
		percentage = statisticSales ? statisticSales.percentage : percentage;
	}

	const bestAverageTitle = "Melhor média possível para sua oferta!";
	const bestAverageText =
		"Podemos emitir passagens com quantidade de milhas menor ou maior do que a média informada. No fim das vendas, a média de milhas por passageiro será igual ou superior à desta oferta.";
	const okAverageTitle = "Tudo bem, tentaremos vender dentro dessa média";
	const okAverageText =
		"Você pode informar a média de milhas por passageiro que deseja vender na MaxMilhas. No fim das vendas, a média será igual ou superior à desta oferta.";
	const alertAverageTitle = "A venda para médias de milhas maiores que 15.000 podem demorar";
	const alertAverageText =
		"Você pode informar a média de milhas por passageiro que deseja vender na MaxMilhas. No fim das vendas, a média será igual ou superior à desta oferta.";
	const dangerAverageTitle = "Atencão! Essa venda pode demorar muito";
	const dangerAverageText = `Esta média representa apenas ${percentage}% das nossas vendas. Quer fazer uma venda mais rápida? Diminua o valor da sua oferta. Podemos emitir passagens com quantidade de milhas menor ou maior do que a média informada. No fim das vendas, a média de milhas por passageiro será igual ou superior à desta oferta.`;

	return (
		<>
			{averageMilesSuggestion == averageMiles ? (
				<>
					<p className="info-text">
						{bestAverageTitle}&nbsp;
						<span>{intFormat(averageMilesSuggestion || 0)}</span>
					</p>
					<TooltipOffers
						position="bottom-start"
						content={<p style={{ fontWeight: "bold", textAlign: "left" }}>{bestAverageText}</p>}
					/>
				</>
			) : averageMiles >= minMiles && averageMiles <= 15000 ? (
				<>
					<p className="info-text">{okAverageTitle}&nbsp;</p>
					<TooltipOffers
						position="bottom-start"
						content={<p style={{ fontWeight: "bold", textAlign: "left" }}>{okAverageText}</p>}
					/>
				</>
			) : averageMiles > 15000 && averageMiles <= 25000 ? (
				<>
					<p className="info-text">{alertAverageTitle}&nbsp;</p>
					<TooltipOffers
						position="bottom-start"
						content={<p style={{ fontWeight: "bold", textAlign: "left" }}>{alertAverageText}</p>}
					/>
				</>
			) : averageMiles > 25000 && averageMiles <= maxAverage ? (
				<>
					<p className="info-text">{dangerAverageTitle}&nbsp;</p>
					<TooltipOffers
						position="bottom-start"
						content={<p style={{ fontWeight: "bold", textAlign: "left" }}>{dangerAverageText}</p>}
					/>
				</>
			) : null}
		</>
	);
};
